<div class="page-header--container white--curve" [ngStyle]="pageHeaderStyle">
    <div class="content--wrapper">
        <a routerLink="/th/News">
            <i class="fas fa-chevron-left"></i>
            <span>{{language.back}}</span>
        </a>
        <div class="row">
            <div *ngIf="file_pdf == 'no'" class="col-12">
                <div #insertDotdotdot class="insert-dotdotdot col-12">
                    <h1 class="title insert-dotdotdot">{{newsTitle}}</h1>
                </div>
                <div class="col-12">
                    <time *ngIf="flag == 'th'">{{newsDate}}</time>
                    <time *ngIf="flag == 'en'">{{newsDate | date:'dd MMMM yyyy'}}</time>
                </div>
            </div>

            <div *ngIf="file_pdf == 'yes'" class="col-8">
                <div #insertDotdotdot class="insert-dotdotdot col-12">
                    <h1 class="title insert-dotdotdot">{{newsTitle}}</h1>
                </div>
                <div class="col-12">
                    <time *ngIf="flag == 'th'">{{newsDate}}</time>
                    <time *ngIf="flag == 'en'">{{newsDate | date:'dd MMMM yyyy'}}</time>
                </div>
            </div>

            <div *ngIf="file_pdf == 'yes'" class="col-4 text-right">
                <a href="{{pdfUrl_path}}" target="_blank" download>
                    <app-button style="margin-top: 32px;" text="{{language.funddetailthm4detail5}} {{filesize}}"></app-button>
                </a>
            </div>
        </div>
    </div>
</div>

<section class="content-inner">
    <div class="container">
        <section class="content-detail">
            <div class="row">
                <div [ngSwitch]="newsType" rel="layout-detail">
                    <div *ngSwitchCase="'text'">
                        <div *ngIf="flag == 'th'; else elsetext">
                            <div class="info" *ngFor="let item of showNews" [innerHTML]="item.detail">
                            </div>
                        </div>
                        <ng-template #elsetext>
                            <div class="info" *ngFor="let item of showNews" [innerHTML]="item.detail_en">
                            </div>
                        </ng-template>
                    </div>
                    <div *ngSwitchCase="'image'">
                        <div class="info" *ngFor="let item of showNews">
                            <div *ngIf="flag == 'th'; else elseimage">
                                <img src="{{item.detail}}" alt="">
                            </div>
                            <ng-template #elseimage>
                                <img src="{{item.detail_en}}" alt="">
                            </ng-template>
                        </div>
                    </div>
                    <div *ngSwitchCase="'vdo'">
                        <div class="info" *ngFor="let item of showNews">
                            <youtube-player [videoId]="id" (ready)="savePlayer($event)" (change)="onStateChange($event)" width="100%" height="800px">
                            </youtube-player>
                        </div>
                    </div>
                    <div *ngSwitchCase="'pdf'">
                        <div class="info" *ngFor="let item of showNews" style="height: 800px">
                            <embed [src]="pdfUrl" type="application/pdf" width="100%" height="100%">
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</section>